import React from 'react';
import './SplashScreen.css';

function SplashScreen() {
  return (
    <div className="splash-screen">
      <div className="splash-content">
        <div className="splash-emoji">
          <img src="/app-icon.png" alt="The Crapper Mapper" />
        </div>
        <h1 className="splash-title">The Crapper Mapper</h1>
        <p className="splash-subtitle">Find the best restrooms on the go</p>
        <div className="splash-loading">
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;
